




import { Component } from 'vue-property-decorator';
import ColoredButtons from './ColoredButtons';

@Component({})
export default class NpsButtonsColored extends ColoredButtons {
  public get colors(): string[] {
    return [
      '#d02325',
      '#d02325',
      '#d02325',
      '#d02325',
      '#d02325',
      '#d02325',
      '#d02325',
      '#ffc729',
      '#ffc729',
      '#67b64d',
      '#67b64d',
    ];
  }
}
